document.addEventListener('DOMContentLoaded', () => {

	if(document.querySelector("#collection-select-trigger") != null) {
		document.querySelector("#collection-select-trigger span.active").innerText = document.querySelector(".custom-option.selected").innerText

	}

	if(window.location.pathname.includes('tagged')) {
		let tag_url = window.location.pathname.split('tagged/')[1];

		tag_url = tag_url.split('-');
	  for (var i = 0; i < tag_url.length; i++) {
	      tag_url[i] = tag_url[i].charAt(0).toUpperCase() + tag_url[i].slice(1);
	  }
	  tag_url = tag_url.join(' ');

		document.querySelector('.custom-select__trigger span.active').textContent = tag_url;
	}

	// opening
	document.querySelector('.custom-select__wrapper').addEventListener('click', function() {
		this.querySelector('.custom-select').classList.toggle('open');
	})

	for (const option of document.querySelectorAll(".custom-option")) {
		option.addEventListener('click', function(event) {
			if (event.currentTarget.closest('form').id = "FacetSortForm"){
				url = new URL(window.location.href)
				filters = new URLSearchParams(url.search)
				filters.set('sort_by', event.currentTarget.dataset.value)
				url.search = filters
				window.location = url
				return 
			}
			if(!this.classList.contains('selected')) {
				this.parentNode.querySelector('.custom-option.selected')?.classList.remove('selected');
				this.classList.add('selected');
				this.closest('.custom-select').querySelector('.custom-select__trigger span.active').textContent = this.textContent;

				const select = document.querySelector('.select--steering');
				select.value = this.getAttribute("value");
				document.getElementById("FacetSortForm").submit()
			}
		})
	}
});

// out of frame
window.addEventListener('click', function(e) {
	const select = document.querySelector('.custom-select')
	if (!select.contains(e.target)) {
		select.classList.remove('open');
	}
});